import {getTraitCategoriesService} from '@/services/traitCategoriesService'
import {TraitCategories} from '@/types/paramFilters/traitCategories'

export function getTraitCategoriesUseCase(signal?: AbortSignal): Promise<TraitCategories> {
  return getTraitCategoriesService(signal)
}
